import { render, staticRenderFns } from "./FolderRenameDialog.vue?vue&type=template&id=541ef289&scoped=true"
import script from "./FolderRenameDialog.vue?vue&type=script&lang=ts"
export * from "./FolderRenameDialog.vue?vue&type=script&lang=ts"
import style0 from "./FolderRenameDialog.vue?vue&type=style&index=0&id=541ef289&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541ef289",
  null
  
)

export default component.exports